import LegalLayout from "@/components/LegalLayout";

const PRIVACY_EMAIL = "giovannimichael94@hotmail.it";

const Section = ({ n, title, children }) => (
  <section className="mt-10 md:mt-12">
    <h2 className="font-display text-2xl md:text-3xl font-medium tracking-[-0.03em] text-lava">
      <span className="text-terracotta font-mono text-base mr-3">
        {String(n).padStart(2, "0")}
      </span>
      {title}
    </h2>
    <div className="mt-4 space-y-4">{children}</div>
  </section>
);

const PrivacyPolicy = () => {
  return (
    <LegalLayout
      eyebrow="Informativa privacy"
      title={
        <>
          Privacy Policy.
          <br />
          <span className="font-medium text-olive">Trasparenza prima di tutto.</span>
        </>
      }
      lastUpdate="07 maggio 2026"
      testid="privacy-page"
    >
      <p className="text-lg">
        Ai sensi del Regolamento (UE) 2016/679 ("GDPR") e del D.Lgs. 196/2003
        e successive modifiche, Pantelflora S.N.C. fornisce di seguito le
        informazioni relative al trattamento dei dati personali raccolti
        tramite il presente sito web.
      </p>

      <Section n={1} title="Titolare del trattamento">
        <p>
          Pantelflora S.N.C.
          <br />
          Via De Amicis, 5 — 91017 Pantelleria (TP), Italia
          <br />
          C.F. / P.IVA: IT01656050810
          <br />
          Tel. fisso: 0923 913129
          <br />
          Cell. (Michael Guida): 388 193 7674
          <br />
          Email per privacy:{" "}
          <a
            href={`mailto:${PRIVACY_EMAIL}`}
            data-testid="privacy-email-link"
            className="underline underline-offset-2 hover:text-olive"
          >
            {PRIVACY_EMAIL}
          </a>
        </p>
      </Section>

      <Section n={2} title="Tipi di dati raccolti">
        <p>
          Il sito raccoglie, esclusivamente quando volontariamente forniti
          dall'utente attraverso il modulo di richiesta preventivo, i
          seguenti dati personali:
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Nome e cognome</li>
          <li>Numero di telefono</li>
          <li>Indirizzo email</li>
          <li>Località di interesse a Pantelleria (facoltativo)</li>
          <li>Servizio richiesto e contenuto del messaggio</li>
        </ul>
        <p>
          Il sito non utilizza cookie di profilazione né strumenti di
          tracciamento di terze parti. Per i dettagli sui cookie tecnici
          consulta la{" "}
          <a
            href="/cookie-policy"
            className="underline underline-offset-2 hover:text-olive"
          >
            Cookie Policy
          </a>
          .
        </p>
      </Section>

      <Section n={3} title="Finalità del trattamento">
        <p>I dati raccolti sono trattati esclusivamente per:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            rispondere alla richiesta di preventivo o informazioni inviata
            tramite il modulo o tramite WhatsApp;
          </li>
          <li>
            gestire eventuali rapporti contrattuali derivanti dalla richiesta;
          </li>
          <li>
            adempiere ad obblighi di legge fiscali, contabili e amministrativi.
          </li>
        </ul>
      </Section>

      <Section n={4} title="Base giuridica">
        <p>
          Il trattamento dei dati si fonda sul consenso dell'interessato
          (art. 6, par. 1, lett. a GDPR), espresso con l'invio volontario del
          modulo, nonché sull'esecuzione di misure precontrattuali richieste
          dall'interessato (art. 6, par. 1, lett. b GDPR) e sull'adempimento
          di obblighi legali (art. 6, par. 1, lett. c GDPR).
        </p>
      </Section>

      <Section n={5} title="Modalità del trattamento e conservazione">
        <p>
          I dati sono trattati con strumenti elettronici, archiviati su
          server gestiti da fornitori che garantiscono adeguate misure di
          sicurezza, e conservati per il tempo strettamente necessario al
          perseguimento delle finalità sopra indicate, comunque non oltre
          24 mesi dall'ultimo contatto, salvo diversi obblighi di legge.
        </p>
      </Section>

      <Section n={6} title="Comunicazione dei dati">
        <p>
          I dati non sono diffusi né ceduti a terzi a fini commerciali.
          Possono essere comunicati a soggetti la cui facoltà di accesso è
          riconosciuta da disposizioni di legge o normative secondarie, e a
          fornitori tecnici (es. servizio di hosting) nominati responsabili
          del trattamento ai sensi dell'art. 28 GDPR.
        </p>
      </Section>

      <Section n={7} title="Diritti dell'interessato">
        <p>
          In ogni momento puoi esercitare i diritti riconosciuti dagli
          articoli da 15 a 22 del GDPR, in particolare:
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>accesso ai tuoi dati;</li>
          <li>rettifica o cancellazione;</li>
          <li>limitazione od opposizione al trattamento;</li>
          <li>portabilità dei dati;</li>
          <li>revoca del consenso in qualunque momento;</li>
          <li>
            reclamo all'Autorità Garante per la protezione dei dati personali
            (www.garanteprivacy.it).
          </li>
        </ul>
        <p>
          Per esercitare i tuoi diritti scrivi a{" "}
          <a
            href={`mailto:${PRIVACY_EMAIL}`}
            className="underline underline-offset-2 hover:text-olive"
          >
            {PRIVACY_EMAIL}
          </a>
          .
        </p>
      </Section>

      <Section n={8} title="Modifiche">
        <p>
          La presente informativa può essere aggiornata in qualsiasi momento.
          La versione vigente è quella pubblicata su questa pagina con
          relativa data di aggiornamento.
        </p>
      </Section>
    </LegalLayout>
  );
};

export default PrivacyPolicy;
